import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { bindReferralCode } from '../api/referral';
import {
  captureReferralFromUrl,
  clearStoredReferralCode,
  getStoredReferralCode,
} from '../lib/referralCapture';

/** Persist ?ref= and bind after login without removing other auth flows. */
export function ReferralBootstrap() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    captureReferralFromUrl(location.search);
  }, [location.search]);

  useEffect(() => {
    if (!user) return;
    const code = getStoredReferralCode();
    if (!code) return;
    let cancelled = false;
    void bindReferralCode(code)
      .then((res) => {
        if (cancelled) return;
        if (res.bound || res.reason === 'already_bound' || res.reason === 'self_referral') {
          clearStoredReferralCode();
        }
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [user?.public_id]);

  return null;
}
